import { applyMiddleware, createStore, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import { identityActions } from '@figure/frontlib-onboarding-redux';
import { initialState as identityInitialState } from '@figure/frontlib-onboarding-redux/lib/reducers/identity-reducer';
import { featureCheck } from '@figure/frontlib-util';
import rootReducer from 'reducers';
import { setupAuthInterceptor } from 'auth';
import { isLocalhost } from 'shared/utils';
import { createAppSocketMiddleware } from './middleware';

const middleware = [
  createAppSocketMiddleware(),
  thunk, // thunk middleware allows us to return promises from and receive dispatch reference in redux action creators.
];
const enhancers = [];

if (process.env.REACT_APP_ENV !== 'production') {
  // Setup redux dev-tools extension https://github.com/zalmoxisus/redux-devtools-extension
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__; // eslint-disable-line no-underscore-dangle

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const sessionKey = 'jwt';
const jwt = featureCheck.localStorage ? window.localStorage.getItem(sessionKey) : '';

setupAuthInterceptor(jwt);

const preloadedState = {
  identityReducer: {
    ...identityInitialState,
    jwt,
  },
};

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(combineReducers({ ...rootReducer }), preloadedState, composedEnhancers);

if (featureCheck.localStorage) {
  // Ensure that the JWT is always up to date in local storage.
  store.subscribe(() => {
    const state = store.getState();

    window.localStorage.setItem(sessionKey, state.identityReducer.jwt);
  });

  // Handle multiple tabs open and log out or timeout.
  window.addEventListener('storage', () => {
    const state = store.getState();
    const { jwt } = state.identityReducer;
    const storeJwt = window.localStorage.getItem(sessionKey);

    if (jwt) {
      if (!storeJwt) {
        store.dispatch(identityActions.timeout());
        window.location.href = isLocalhost() ? '/applications/start' : process.env.REACT_APP_LOGIN_PATH;
      }
    }
  });
}

export default store;
